<template>
	<div class="page-width">
		<datatable title="Companies" :response="data" :fields="fields" :operations="operations" @create="createNewCompany" @edit_click="edit" 
				   @stats="openStatsModal" @files="files" :show_delete="false">
		</datatable>
	</div>
</template>
<script>
	import { mapMutations } from 'vuex'
	import Datatable from '@/components/Datatable'
	export default {
		name: 'companies',
		data(){
			return {
				fields: [
				    {
				      name: 'Name',
				      value: 'name',
				      additional_data: {
				      	resource_type: 'Company'
				      },
				      component: 'LinkEntity'
				    },
				    {
				      name: 'Is Discreet',
				      value: 'is_discreet'
				    },
				    {
				      name: 'Percentage',
				      value: 'percentage'
				    },
				    {
				      name: 'Message',
				      value: 'message',
				      is_html: true
				    },
				    {
				      name: 'Email',
				      value: 'email'
				    },
				    {
				      name: 'Has Contract',
				      value: 'has_contract'
				    },
				    {
				      name: 'Contact Details',
				      value: 'contact_details',
				      is_html: true,
				    },
				],
				data: [],
				operations: [
					{ name: 'Offers', component: 'CompanyOffersRouterLink' },
					{ name: 'Stats' },
					{ name: 'Files' }
				]
			}
		},
		created(){
			this.$network_utils.getCompanies().then(response => {
          		response = Array.isArray(response) ? response : [response]
				this.data = response
			})
		},
		methods: {
			createNewCompany(){
				this.createModal({
					component_name: 'CompanyForm',
					modal_title: 'Create New Company',
					is_create: true
				})
			},
			edit(data){
				this.createModal({
					component_name: 'CompanyForm',
					modal_title: data.name,
					data
				})	
			},
			openStatsModal(data){
				this.createModal({
					component_name: 'ResourceStatsForm',
					modal_title: 'Stats - ' + data.name,
					resource_type: 'Company',
					resource_id: data.id
				})	
			},
			files(data){
				this.createModal({
					component_name: 'FilesModal',
					modal_title: `Files - ${data.name}`,
					resource_id: data.id,
					resource_type: 'Company'
				})
			},
			...mapMutations('modals', ['createModal'])
		},
		components: {
			Datatable
		}
	}
</script>